module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }